const copyToClipboard = () => {
    const shareLinkBtns = document.querySelectorAll(".copyToClipboardBtn");

    const changeText = (btn, success) => {
        if (success) {
            btn.classList.add("copied");
            setTimeout(() => {
                btn.classList.remove("copied");
            }, 1000);
        } else {
            btn.classList.add("notCopied");
            setTimeout(() => {
                btn.classList.remove("notCopied");
            }, 1000);
        }
    };

    const fallbackCopy = (text, btn) => {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        try {
            document.execCommand('copy');
            changeText(btn, true);
        } catch (e) {
            changeText(btn, false);
        }
        document.body.removeChild(textarea);
    };

    const toCopy = (clickedBtn) => {
        const url = window.location.href;

        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(url).then(
                () => changeText(clickedBtn, true),
                () => fallbackCopy(url, clickedBtn)
            );
        } else {
            fallbackCopy(url, clickedBtn);
        }
    };

    if (shareLinkBtns.length) {
        Array.from(shareLinkBtns).forEach((btn) => {
            btn.addEventListener("click", () => toCopy(btn));
        });
    }
};

export { copyToClipboard };
